module.exports = __webpack_public_path__ + "static/media/savio_white.f3f44e08.jpg";